<div class="flex flex-row items-start justify-start">
  <div
    class="ml-5 flex h-[36px] w-10 items-center justify-start"
    *ngIf="fraction.type !== fractionTypeStoreFraction || !!fieldResult"
  >
    {{
      !isFirst && fraction.operator === fractionOperatorEnum.Or
        ? 'OR'
        : !isFirst && fraction.operator === fractionOperatorEnum.And
          ? 'AND'
          : ''
    }}
  </div>

  <div
    *ngIf="fraction.type !== fractionTypeStoreFraction"
    [ngSwitch]="fieldResult"
    class="ml-5 flex flex-row items-start justify-start"
  >
    <m-fraction-number
      *ngSwitchCase="fieldResultEnum.Number"
      [fraction]="fraction"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-number>

    <m-fraction-string
      *ngSwitchCase="fieldResultEnum.String"
      [suggestModelDimension]="suggestModelDimension"
      [structId]="structId"
      [chartId]="chartId"
      [dashboardId]="dashboardId"
      [reportId]="reportId"
      [rowId]="rowId"
      [fraction]="fraction"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-string>

    <m-fraction-day-of-week
      *ngSwitchCase="fieldResultEnum.DayOfWeek"
      [fraction]="fraction"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-day-of-week>

    <m-fraction-day-of-week-index
      *ngSwitchCase="fieldResultEnum.DayOfWeekIndex"
      [fraction]="fraction"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-day-of-week-index>

    <m-fraction-month-name
      *ngSwitchCase="fieldResultEnum.MonthName"
      [fraction]="fraction"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-month-name>

    <m-fraction-quarter-of-year
      *ngSwitchCase="fieldResultEnum.QuarterOfYear"
      [fraction]="fraction"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-quarter-of-year>

    <m-fraction-ts
      *ngSwitchCase="fieldResultEnum.Ts"
      [fraction]="fraction"
      [fieldTimeframe]="fieldTimeframe"
      [isMetrics]="false"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-ts>

    <m-fraction-boolean
      *ngSwitchCase="fieldResultEnum.Boolean"
      [fraction]="fraction"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-boolean>

    <m-fraction-yesno
      *ngSwitchCase="fieldResultEnum.Yesno"
      [fraction]="fraction"
      [isFirst]="isFirst"
      [fractionIndex]="fractionIndex"
      [isDisabled]="isDisabled"
      (fractionUpdate)="fractionUpdate.emit($event)"
    ></m-fraction-yesno>
  </div>

  <div
    *ngIf="fraction.type === fractionTypeStoreFraction"
    class="flex flex-row items-start justify-start"
  >
    <!-- <div class="ml-5 flex h-[36px] w-10 items-center justify-start"></div> -->

    <div *ngIf="!!fieldResult" class="flex">
      <m-store-fraction-sub-type
        class="ml-5"
        [fraction]="fraction"
        [storeContent]="storeContent"
        [fieldResult]="fieldResult"
        [isFirst]="isFirst"
        [fractionIndex]="fractionIndex"
        [isDisabled]="isDisabled"
        (fractionUpdate)="fractionUpdate.emit($event)"
      >
      </m-store-fraction-sub-type>
    </div>

    <div *ngFor="let fractionControl of fraction.controls" class="ml-5 flex">
      <m-store-fraction-selector
        *ngIf="fractionControl.controlClass === controlClassSelector"
        [fraction]="fraction"
        [isFirst]="isFirst"
        [fractionIndex]="fractionIndex"
        [isDisabled]="isDisabled"
        [fractionControl]="fractionControl"
        (fractionUpdate)="fractionUpdate.emit($event)"
      >
      </m-store-fraction-selector>

      <m-store-fraction-input
        *ngIf="fractionControl.controlClass === controlClassInput"
        [suggestModelDimension]="suggestModelDimension"
        [structId]="structId"
        [chartId]="chartId"
        [dashboardId]="dashboardId"
        [reportId]="reportId"
        [rowId]="rowId"
        [fraction]="fraction"
        [isFirst]="isFirst"
        [fractionIndex]="fractionIndex"
        [isDisabled]="isDisabled"
        [fractionControl]="fractionControl"
        (fractionUpdate)="fractionUpdate.emit($event)"
      >
      </m-store-fraction-input>

      <m-store-fraction-switch
        *ngIf="fractionControl.controlClass === controlClassSwitch"
        [fraction]="fraction"
        [isFirst]="isFirst"
        [fractionIndex]="fractionIndex"
        [isDisabled]="isDisabled"
        [fractionControl]="fractionControl"
        (fractionUpdate)="fractionUpdate.emit($event)"
      >
      </m-store-fraction-switch>

      <m-store-fraction-date-picker
        *ngIf="fractionControl.controlClass === controlClassDatePicker"
        [metricsStartDateYYYYMMDD]="metricsStartDateYYYYMMDD"
        [metricsEndDateYYYYMMDD]="metricsEndDateYYYYMMDD"
        [isMetricsPage]="isMetricsPage"
        [fraction]="fraction"
        [isFirst]="isFirst"
        [fractionIndex]="fractionIndex"
        [isDisabled]="isDisabled"
        [fractionControl]="fractionControl"
        (fractionUpdate)="fractionUpdate.emit($event)"
      >
      </m-store-fraction-date-picker>
    </div>
  </div>
</div>
